import {
  CirculoTareaCentro,
  CirculoTareaSiguiente,
  LineaTarea,
  PasosTurnoContainer,
} from "./localStyle";

const PasosTurnoTareas = ({
  tarea,
  pasos,
  distance,
  distance2,
  distance3,
  transicionTerminada,
}) => {
  return (
    <PasosTurnoContainer $show={tarea + 1 === pasos.length}>
      <LineaTarea
        $paso={tarea}
        $distancia={distance}
        $distancia2={distance2}
        $distancia3={distance3}
      />

      <CirculoTareaSiguiente
        $mostrar={transicionTerminada}
      />
      {tarea + 1 === pasos.length && <CirculoTareaCentro />}
    </PasosTurnoContainer>
  );
};

export default PasosTurnoTareas;
